export default __webpack_public_path__ + "static/media/gallery - bezoar_01.2856f901.jpg";